import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overlay-banner has-background-info"
}
const _hoisted_2 = { class: "field is-grouped mb-4" }
const _hoisted_3 = { class: "control is-expanded" }
const _hoisted_4 = { class: "control" }
const _hoisted_5 = { class: "control" }
const _hoisted_6 = { class: "list-table-container" }
const _hoisted_7 = { class: "list-table-container" }
const _hoisted_8 = { class: "ellipsis-cell" }
const _hoisted_9 = ["onClick", "title"]
const _hoisted_10 = { class: "has-text-centered mt-4 mb-4" }
const _hoisted_11 = {
  class: "modal-card",
  style: {"width":"900px","max-width":"95vw"}
}
const _hoisted_12 = { class: "modal-card-head" }
const _hoisted_13 = { class: "modal-card-title" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "modal-card-body" }
const _hoisted_16 = {
  key: 0,
  class: "fermi-json-editor message-json-editor"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "message-pre" }
const _hoisted_19 = { class: "modal-card-foot is-justify-content-space-between" }
const _hoisted_20 = {
  key: 0,
  class: "modal-meta-bottom"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_input = _resolveComponent("b-input")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_table_column = _resolveComponent("b-table-column")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_JsonEditorVue = _resolveComponent("JsonEditorVue")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showDisconnectedOverlay && !_ctx.isMqttConnected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t('events.streamDisconnected')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(['table-content', { 'is-dimmed': _ctx.showDisconnectedOverlay && !_ctx.isMqttConnected }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_b_input, {
            type: "search",
            size: _ctx.size,
            icon: "magnify",
            placeholder: _ctx.$t('events.searchPlaceholder'),
            modelValue: _ctx.searchQuery,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event))
          }, null, 8, ["size", "placeholder", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_b_button, {
            size: _ctx.size,
            class: _normalizeClass({ 'is-info': !_ctx.isPaused, 'is-warning': _ctx.isPaused }),
            onClick: _ctx.togglePause,
            title: _ctx.isPaused ? _ctx.$t('events.playTooltip') : _ctx.$t('events.pauseTooltip'),
            "icon-left": _ctx.isPaused ? 'play' : 'pause'
          }, null, 8, ["size", "class", "onClick", "title", "icon-left"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_b_button, {
            size: _ctx.size,
            class: "is-danger",
            onClick: _ctx.clearEvents,
            title: _ctx.$t('events.clearTooltip'),
            "icon-left": "delete"
          }, null, 8, ["size", "onClick", "title"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_b_table, {
            data: _ctx.filteredEvents,
            striped: "",
            loading: _ctx.isLoading,
            scrollable: Boolean(_ctx.maxHeight),
            "max-height": _ctx.maxHeight,
            onClick: _ctx.handleRowClick
          }, {
            empty: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.filteredEvents.length === 0 && _ctx.events.length > 0 ? _ctx.$t('events.noSearchResults') : _ctx.$t('events.noEvents')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_b_table_column, {
                field: "topic",
                label: _ctx.$t('events.topic'),
                width: "25%"
              }, {
                default: _withCtx((props) => [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(props.row.topic), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_b_table_column, {
                field: "message",
                label: _ctx.$t('events.message')
              }, {
                default: _withCtx((props) => [
                  _createElementVNode("div", {
                    class: "ellipsis-cell clickable",
                    onClick: ($event: any) => (_ctx.openMessageModal(props.row)),
                    title: _ctx.$t('events.message')
                  }, _toDisplayString(props.row.message), 9, _hoisted_9)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_b_table_column, {
                field: "time",
                label: _ctx.$t('events.time'),
                numeric: "",
                width: "25%"
              }, {
                default: _withCtx((props) => [
                  _createTextVNode(_toDisplayString(_ctx.$d(new Date(props.row.time), 'shortSeconds')), 1)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }, 8, ["data", "loading", "scrollable", "max-height", "onClick"])
        ])
      ])
    ], 2),
    _createVNode(_component_b_modal, {
      modelValue: _ctx.messageModalOpen,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.messageModalOpen) = $event)),
      "has-modal-card": "",
      "trap-focus": "",
      "destroy-on-hide": true,
      "aria-role": "dialog",
      "can-cancel": ['escape','x','outside'],
      "aria-label": "Event Message",
      "close-button-aria-label": "Close",
      "aria-modal": ""
    }, {
      default: _withCtx((props) => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("header", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.selectedRow ? _ctx.selectedRow.topic : ''), 1),
            _createElementVNode("button", {
              class: "delete",
              "aria-label": "close",
              onClick: props.close
            }, null, 8, _hoisted_14)
          ]),
          _createElementVNode("section", _hoisted_15, [
            (_ctx.selectedMessageIsJson)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_JsonEditorVue, {
                    modelValue: _ctx.selectedMessageJson,
                    mode: _ctx.jsonEditorMode,
                    stringified: false,
                    "main-menu-bar": false,
                    "navigation-bar": false,
                    "status-bar": false,
                    readOnly: true,
                    style: {"height":"60vh"}
                  }, null, 8, ["modelValue", "mode"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("pre", _hoisted_18, _toDisplayString(_ctx.selectedMessageText), 1)
                ]))
          ]),
          _createElementVNode("footer", _hoisted_19, [
            _createVNode(_component_b_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.messageModalOpen = false))
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Close", -1)
              ]))]),
              _: 1
            }),
            (_ctx.selectedRow)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$d(new Date(_ctx.selectedRow.time), 'shortAll')), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}